import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["wrapper", "table", "exportCount", "exportButton", "showMoreButton", "tbody"]
    static values = {
        exchangesCount: Number,
        btcPrice: Number
    }

    connect() {
        this.setupShowMoreButton()
    }

    setupShowMoreButton() {
        if (this.hasShowMoreButtonTarget && this.hasTbodyTarget) {
            this.showMoreButtonTarget.addEventListener('click', () => {
                const hiddenRows = this.tbodyTarget.querySelectorAll('tr.hidden')
                hiddenRows.forEach(row => {
                    row.classList.remove('hidden')
                })
                this.showMoreButtonTarget.style.display = 'none'
            })
        }
    }

    async exportImage() {
        const limit = parseInt(this.exportCountTarget.value, 10)
        const rows = Array.from(this.tableTarget.querySelectorAll('tbody tr'))
        const toHide = rows.slice(limit)
        const websiteCols = Array.from(this.tableTarget.querySelectorAll('.website-column'))

        // 临时隐藏多余行和官网列
        toHide.forEach(r => r.style.display = 'none')
        websiteCols.forEach(el => el.style.display = 'none')

        try {
            // 动态加载 html2canvas
            if (!window.html2canvas) {
                await this.loadHtml2Canvas()
            }

            // 生成截图
            const canvas = await this.generateScreenshot()

            // 添加水印
            // this.addWatermark(canvas)

            // 下载图片
            this.downloadImage(canvas, limit)

        } catch (error) {
            console.error('导出失败', error)
            alert('导出失败，请重试')
        } finally {
            // 恢复显示
            toHide.forEach(r => r.style.display = '')
            websiteCols.forEach(el => el.style.display = '')
        }
    }

    async loadHtml2Canvas() {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script')
            script.src = 'https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js'
            script.onload = resolve
            script.onerror = reject
            document.body.appendChild(script)
        })
    }

    async generateScreenshot() {
        const root = document.querySelector('.min-h-screen') || this.wrapperTarget
        const bg = getComputedStyle(root).backgroundColor || '#111827'
        const scale = Math.max(1, window.devicePixelRatio || 1)

        return await html2canvas(this.wrapperTarget, {
            backgroundColor: bg,
            scale: scale,
            useCORS: true,
            allowTaint: true,
            logging: false
        })
    }

    addWatermark(canvas) {
        const ctx = canvas.getContext('2d')
        ctx.font = 'bold 30px Arial'
        ctx.fillStyle = 'rgba(239, 68, 68, 0.7)'
        ctx.textAlign = 'center'
        ctx.textBaseline = 'middle'
        ctx.fillText('RebateTo.me 手续费聚合返佣平台', canvas.width / 2, canvas.height / 2)
    }

    downloadImage(canvas, limit) {
        const link = document.createElement('a')
        link.download = `exchanges-top-${limit}.jpg`
        link.href = canvas.toDataURL('image/jpeg', 0.9)
        link.click()
    }
}
